import React, { createContext, useContext, useState, useEffect } from "react";

interface AuthContextType {
  isAuthenticated: boolean;
  firstName: string | null;
  lastName: string | null;
  userId: string | null;
  role: string | null;
  logout: () => void;
  login: (firstName: string, lastName: string, userId: string, role:string) => void;
}

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  firstName: null,
  lastName: null,
  userId:  null,
  role: null,
  logout: () => {},
  login: () => {},
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!localStorage.getItem("access_token");
  });
  
  const [firstName, setFirstName] = useState<string | null>(null);
  const [lastName, setLastName] = useState<string | null>(null);
  const [userId, setUserId] = useState<string | null>(null);
  const [role, setRole] = useState<string | null>(null);

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('secondAuthToken'); 
    localStorage.removeItem('first_name');
    localStorage.removeItem('last_name');
    setIsAuthenticated(false);
    setFirstName(null);
    setLastName(null);
    setUserId(null);
    setRole(null);
  };

  const login = (firstName: string, lastName: string, userId: string, role:string) => {
    localStorage.setItem("first_name", firstName);
    localStorage.setItem("last_name", lastName);
    localStorage.setItem("user_id", userId);
    localStorage.setItem("role", role);
    setFirstName(firstName);
    setLastName(lastName);
    setUserId(userId);
    setRole(role);
    setIsAuthenticated(true);
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const userFirstName = localStorage.getItem("first_name");
    const userLastName = localStorage.getItem("last_name");
    const storedId = localStorage.getItem("user_id");
    const storedRole = localStorage.getItem("role");


    if (token) {
      setIsAuthenticated(true);
    }
    if (userFirstName) {
      setFirstName(userFirstName);
    }
    if (userLastName) {
      setLastName(userLastName);
    }
    if (storedId) {
      setUserId(storedId);
    }
    if (storedRole) setRole(storedRole);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, firstName, lastName,userId, role, logout, login  }}>
      {children}
    </AuthContext.Provider>
  );
};
